/**
 * fileToBase64 — Convierte un File a string base64 data URL.
 *
 * Uso típico:
 *   const dataUrl = await fileToBase64(fileInput.files[0]);
 *   // -> "data:image/png;base64,iVBORw0KGgoAAAA..."
 *
 * Devuelve null si no se pasa un archivo válido.
 * Lanza error si lectura falla.
 */
export function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    if (!file) {
      resolve(null);
      return;
    }
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = (err) => reject(err);
    reader.readAsDataURL(file);
  });
}

/**
 * Aproxima el peso decoded en bytes a partir del data URL base64.
 * Útil para validar tamaño antes del upload.
 */
export function approxBase64DecodedSize(dataUrl) {
  if (!dataUrl || typeof dataUrl !== "string") return 0;
  const base64Body = dataUrl.split(",")[1] || "";
  // base64: cada 4 caracteres = 3 bytes. Ajuste por padding.
  const padding = (base64Body.match(/=+$/) || [""])[0].length;
  return Math.floor((base64Body.length * 3) / 4) - padding;
}
